import React from "react";
import MainTemplate from "components/Main/templates/MainTemplate";
import TechStackData from "data/techstackdata.json";
import ExperienceData from "data/experience.json";
import EducationData from 'data/educationdata.json';
import ProjectData from 'data/projectdata.json';
import AwardData from 'data/awarddata.json';

const Main = () => {
  return (
    <div>
      {/* <Contents /> */}
      <MainTemplate>
        <MainTemplate.Profile />
        <MainTemplate.TechStack data={TechStackData} />
        <MainTemplate.Experience data={ExperienceData} />
        <MainTemplate.Education data={EducationData} />
        <MainTemplate.Project data={ProjectData} />
        <MainTemplate.Award data={AwardData} />
      </MainTemplate>
    </div>
  );
};

export default Main;
